"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingsDataPage = void 0;
var React = require("react");
var history_1 = require("history");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var meetings_api_1 = require("../../api/meetings-api");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
require("./meetings.scss");
var browserHistory = history_1.createBrowserHistory({ basename: "" });
var header = {
    items: ['Unidade'],
};
var MeetingsDataPage = /** @class */ (function (_super) {
    __extends(MeetingsDataPage, _super);
    function MeetingsDataPage(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.token = null;
        _this.telemetry = null;
        _this.userObjectId = "";
        _this.tenantId = "";
        _this.appSettings = { telemetry: "", theme: "", token: "" };
        /**
         * Change Tipos Categoria.
         * */
        _this.onTipoCategoriaChanged = function (event, data) {
            var tipoCategoria = data.value;
            _this.getMeetingsDataFilter(tipoCategoria);
        };
        Icons_1.initializeIcons();
        var search = window.location.search;
        var params = new URLSearchParams(search);
        _this.theme = params.get("theme");
        _this.telemetry = _this.appSettings.telemetry = params.get("telemetry");
        _this.locale = params.get("locale");
        _this.state = {
            loading: false,
            theme: _this.theme ? _this.theme : "default",
            processoId: (_a = params.get("p")) !== null && _a !== void 0 ? _a : "",
            embed: (_b = params.has("embed")) !== null && _b !== void 0 ? _b : false,
            meetingsData: null,
            selectedMeeting: null,
            appConfigs: null,
            appSettings: null,
            tipoCategoia: null,
        };
        window.localStorage.setItem("appsettings", JSON.stringify(_this.appSettings));
        return _this;
    }
    /**
    * Used to initialize this component.
    */
    MeetingsDataPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getAppConfig();
                this.getAppSettings();
                if (!this.state.embed)
                    this.getMeetingsDataResponse();
                else
                    this.setState({ loading: false, meetingsData: [] });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get Meetings Data
     * */
    MeetingsDataPage.prototype.getMeetingsDataResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loading: true });
                        return [4 /*yield*/, meetings_api_1.getMeetingsData()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                meetingsData: response.data,
                            });
                        }
                        this.setState({ loading: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get Meetings Data Filter
     * */
    MeetingsDataPage.prototype.getMeetingsDataFilter = function (tipoCategoria) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getMeetingsData(tipoCategoria)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                meetingsData: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get App Configs
     * */
    MeetingsDataPage.prototype.getAppConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppConfig()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                appConfigs: response.data,
                            });
                            document.title = this.state.appConfigs.pageTitle;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Get App Settings
     * */
    MeetingsDataPage.prototype.getAppSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppSettings()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                appSettings: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Render the Documentos of processo.
     * */
    MeetingsDataPage.prototype.renderMeetingsData = function () {
        return this.state.meetingsData.map(function (meeting) {
            var horarios = '';
            if (meeting.horarioAtendimentoDias) {
                horarios += "Horários de atendimento: " + meeting.horarioAtendimentoDias;
            }
            if (meeting.horarioAtendimentoInicial) {
                horarios += " das " + meeting.horarioAtendimentoInicial;
            }
            if (meeting.horarioAtendimentoFinal) {
                horarios += " até " + meeting.horarioAtendimentoFinal + " (Horário de Brasília)";
            }
            return {
                'key': meeting.Ancora,
                'header': (React.createElement(react_northstar_1.Flex, { gap: "gap.medium", vAlign: "center" },
                    React.createElement(react_northstar_1.Flex, null, meeting.name),
                    horarios != "" &&
                        React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "clock-icon", iconName: "Clock" }), content: horarios, position: "after", align: "center" }))),
                'content': '',
                'endMedia': (React.createElement(react_northstar_1.Flex, { gap: "gap.large" },
                    React.createElement(react_northstar_1.Button, { icon: React.createElement(react_icons_northstar_1.TeamsMonochromeIcon, null), content: "Entrar", onClick: function () { window.open("/meeting/" + meeting.Ancora); }, primary: true })))
            };
        });
    };
    /**
     * Render the Tipos Categoria.
     * */
    MeetingsDataPage.prototype.getItemsTipoCategoria = function () {
        var _a, _b;
        var items;
        if (this.state.embed) {
            items = [];
        }
        else {
            items = [
                {
                    name: "TODOS",
                    key: "TODOS",
                    label: "TODOS",
                    value: "TODOS",
                }
            ];
        }
        (_b = (_a = this.state.appSettings) === null || _a === void 0 ? void 0 : _a.tipoCategoria) === null || _b === void 0 ? void 0 : _b.map(function (tipoCategoria, index) {
            items.push({
                name: tipoCategoria,
                key: (index + 1).toString(),
                label: tipoCategoria,
                value: tipoCategoria,
            });
        });
        return items;
    };
    /**
     * Render this component.
     * */
    MeetingsDataPage.prototype.render = function () {
        var _a, _b, _c, _d;
        if (this.state.loading) {
            return (React.createElement(react_northstar_1.Flex, { gap: "gap.small", hAlign: "center", vAlign: "center", styles: { margin: "20% 0" } },
                React.createElement(react_northstar_1.Flex.Item, { align: "end" },
                    React.createElement(react_northstar_1.Loader, { label: "Carregando..." }))));
        }
        else if (this.state.meetingsData) {
            return (React.createElement(React.Fragment, null,
                this.state.appConfigs &&
                    React.createElement("div", { hidden: this.state.embed, className: "header" },
                        React.createElement(react_northstar_1.Segment, { className: "headerLine", inverted: true },
                            React.createElement(react_northstar_1.Flex, null,
                                React.createElement(react_northstar_1.Flex.Item, null,
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", vAlign: "center" },
                                        React.createElement(react_northstar_1.Image, { src: "/images/logo.png" }),
                                        React.createElement(react_northstar_1.Text, { weight: "semibold", content: "BALC\u00C3O VIRTUAL", size: "medium" }))),
                                React.createElement(react_northstar_1.Flex.Item, { grow: true },
                                    React.createElement(react_northstar_1.Flex, { hAlign: "center", vAlign: "center" },
                                        React.createElement(react_northstar_1.Label, { className: "headerLabel", content: this.state.appConfigs.tribunal }))),
                                React.createElement(react_northstar_1.Flex.Item, null,
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", vAlign: "center", className: "sobre" },
                                        React.createElement(react_icons_northstar_1.InfoIcon, { outline: true }),
                                        React.createElement(react_northstar_1.Text, { weight: "light", content: "Sobre", size: "small" })))))),
                React.createElement(react_northstar_1.Flex, { gap: "gap.small", hAlign: "center", vAlign: "center", column: true, padding: "padding.medium" },
                    React.createElement(react_northstar_1.Flex.Item, { align: "center" },
                        React.createElement(react_northstar_1.Box, { className: this.state.embed ? "box-meetings fill" : "box-meetings" },
                            ((_a = this.state.appSettings) === null || _a === void 0 ? void 0 : _a.tipoCategoria) &&
                                React.createElement(React.Fragment, null,
                                    React.createElement(react_northstar_1.Flex, null,
                                        React.createElement(react_northstar_1.Flex.Item, { grow: true },
                                            React.createElement(react_northstar_1.RadioGroup, { className: "radioGroupTipoCategoria", defaultCheckedValue: this.state.embed ? "1" : "TODOS", items: this.getItemsTipoCategoria(), onCheckedValueChange: this.onTipoCategoriaChanged }))),
                                    React.createElement(react_northstar_1.Divider, { hidden: this.state.embed && !((_b = this.state.meetingsData) === null || _b === void 0 ? void 0 : _b.length) })),
                            !this.state.embed &&
                                (((_c = this.state.meetingsData) === null || _c === void 0 ? void 0 : _c.length) > 0 ?
                                    React.createElement(react_northstar_1.List, { key: "items-meetings", items: this.renderMeetingsData() })
                                    :
                                        React.createElement(react_northstar_1.Text, { styles: { margin: "10px" }, align: "center", content: "Nenhuma unidade cadastrada." })),
                            this.state.embed &&
                                (((_d = this.state.meetingsData) === null || _d === void 0 ? void 0 : _d.length) > 0 ?
                                    React.createElement(react_northstar_1.List, { key: "items-meetings", items: this.renderMeetingsData() })
                                    :
                                        React.createElement(React.Fragment, null)))))));
        }
        return (React.createElement("div", null));
    };
    return MeetingsDataPage;
}(React.Component));
exports.MeetingsDataPage = MeetingsDataPage;
//# sourceMappingURL=meetings.js.map